var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3600 3600",
    style: {
      enableBackground: "new 0 0 3600 3600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1E;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M738,3550.5l1118.2-1118.2l1118.2,1118.2c32.2,32.3,75.4,49.4,119.4,49.4c21.7,0,43.7-4.2,64.5-12.9 c63.1-26.1,104.2-87.6,104.2-155.9V168.7c0-93.2-75.5-168.7-168.7-168.7h-2475c-93.2,0-168.7,75.5-168.7,168.7v3262.4 c0,68.3,41.1,129.8,104.1,155.9C617.3,3613.4,689.9,3598.8,738,3550.5L738,3550.5z M787.5,337.6h2137.4v2686.4l-949.4-949.4 c-33-33-76.1-49.4-119.3-49.4c-43.2,0-86.4,16.5-119.3,49.4l-949.4,949.4L787.5,337.6z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.1b4e9ff2593fe2f3791615ceec0c7cea.svg";
export { ForwardRef as ReactComponent };